import { render, staticRenderFns } from "./Kueche.vue?vue&type=template&id=f75fd1f4"
import script from "./Kueche.vue?vue&type=script&lang=js"
export * from "./Kueche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports